import {
    SEND_MESSAGE_START,
    SEND_MESSAGE_SUCCESS,
    SEND_MESSAGE_ERROR
} from '../../constants';
import showToaster from '../../helpers/toastrMessgaes/showToaster';
import { createThread as mutation, getAllThreadItems as query } from '../../lib/graphql';

export function sendMessageAction({ bookingId, message }) {
    return async (dispatch, getState, { client }) => {
        try {
            if (!navigator.onLine) {
                showToaster({ messageId: 'networkFailed', toasterType: 'error' })
                return;
            }
            dispatch({
                type: SEND_MESSAGE_START,
            });

            const { data } = await client.mutate({
                mutation,
                variables: {
                    bookingId,
                    message,
                },
                refetchQueries: [
                    {
                        query,
                        variables: {
                            bookingId,
                            offset: 0
                        },
                    }
                ]
            });

            if (data?.createThread?.status === 200) {
                dispatch({
                    type: SEND_MESSAGE_SUCCESS,
                });
            } else {
                await showToaster({ messageId: 'errorMessage', toasterType: 'error', requestContent: data?.createThread?.errorMessage  })
                dispatch({ type: SEND_MESSAGE_ERROR });
            }
        } catch (error) {
            dispatch({
                type: SEND_MESSAGE_ERROR,
                payload: {
                    error,
                },
            });
            return false;
        }
        return true;
    };
}